//
// FormatterFactory.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import ClosetObject from "../ClosetObject";
import "../lib";
import "./Formatter";

var FormatterFactory = createModule("commons::FormatterFactory", [], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        _getFormatter_ss: [1,7,7],
        getSupportedFormatNames: [[7]],
        getNumberOfCachedFormatters: [3],
        getFormatterForFormatName: [1,7],
        getDefaultNumericFormatter: [1],
        _getFormatter_os: [1,1,7],
        getCLDRVersion: [7],
        clearFormatterCache: [0],
    },
    {
        getSharedInstance: [1],
        instance: [1],
    },
    ["getFormatter"],
]);
export default FormatterFactory;
